/* eslint-disable camelcase */
import { locationDeploymentDetailsHtml } from './location_deployment_details'

if (!window.locationCardTemplates) {
  window.locationCardTemplates = {}
}

const locationStateTemplate = (location) => {
  const {
    state,
    state_tag,
    state_timestamp,
    category,
    kg_asset_name,
    has_assets,
    tvid
  } = location
  let locationStateTemplateHtml = ''

  if (category === 'legacy') {
    locationStateTemplateHtml = `
      <div>
        <div><span class="text-sm font-semibold text-secondary text-end">AssetName: ${kg_asset_name || 'N/A'}</span></div>
      </div>`
  } else if (!has_assets) {
    locationStateTemplateHtml = `
      <div class="future-location text-gray-600">
        <div><span class="text-sm font-semibold">Future Location</span></div>
        <div><span class="text-sm">TVID: ${tvid || 'N/A'}</span></div>
      </div>`
  } else {
    locationStateTemplateHtml = `
      <div class="status-bar">
        <div><span class="tag ${state_tag || ''}-tag">${state}</span></div>
        ${
          state === 'Healthy'
          ? ''
          : `<div><span class="timestamp timestamp-${state ? state.toLowerCase() : ''}">Since: ${state_timestamp || 'N/A'}</span></div>`
        }
      </div>`
  }

  return locationStateTemplateHtml
}

const deploymentCollapsibleHtml = (location) => locationDeploymentDetailsHtml(location, { variant: 'card' })

const locationListAssetsTemplate = (assets, showAsset, category, shelterStatuses) => {
  if (!assets || assets.length === 0 || !showAsset) {
    return ''
  }

  if (category === 'combo_shelter' && shelterStatuses && shelterStatuses.length > 0) {
    const assetsByShelter = {}
    const shelterMap = {}

    shelterStatuses.forEach(shelter => {
      shelterMap[shelter.asset_tag_id] = shelter
      assetsByShelter[shelter.asset_tag_id] = []
    })

    assets.forEach(asset => {
      if (asset.kit_asset_tag_id && assetsByShelter[asset.kit_asset_tag_id]) {
        assetsByShelter[asset.kit_asset_tag_id].push(asset)
      } else {
        if (!assetsByShelter.unassigned) {
          assetsByShelter.unassigned = []
        }
        assetsByShelter.unassigned.push(asset)
      }
    })

    const shelterGroupsHtml = Object.entries(assetsByShelter)
      .filter(([_, assets]) => assets.length > 0)
      .map(([shelterId, shelterAssets]) => {
        const shelter = shelterMap[shelterId]
        const shelterName = shelter ? shelter.asset_type : 'Unassigned Assets'
        return `
          <div class="shelter-asset-group">
            <div class="shelter-asset-group-header">
              <span class="font-semibold text-sm">${shelterName}</span>
              ${shelter ? `<span class="tag ${shelter.state_tag || ''}-tag ml-2 text-xs">${shelter.state}</span>` : ''}
            </div>
            <table class="asset-table">
              <tbody>
                ${shelterAssets.map(asset => locationAssetTemplate(asset)).join('')}
              </tbody>
            </table>
          </div>
        `
      }).join('')

    return `
      <div class="secondry-card ${showAsset ? '' : 'hidden'}">
        ${shelterGroupsHtml}
      </div>`
  } else {
    const assetsHtml = `
      <div class="secondry-card ${showAsset ? '' : 'hidden'}">
        <table class="asset-table">
          <tbody>
            ${assets.map(asset => locationAssetTemplate(asset)).join('')}
          </tbody>
        </table>
      </div>`

    return assetsHtml
  }
}

const locationAssetTemplate = ({ asset_type, state, state_tag }) => {
  return `
    <tr>
      <td>${asset_type}</td>
      <td></td>
      <td>
        <span class="tag ${state_tag || ''}-tag">
          ${state}
        </span>
      </td>
    </tr>`
}

const cardContentTemplate = (location, showAssets) => {
  const { name, category, humanized_category, assets, location_card_icon } = location

  const cardContentTemplateHtml = `
    <div class="card-title">
      ${location_card_icon || ''}
      <span>${humanized_category || category}</span>
      ${assets && assets.length > 0 ? `<span>(${assets.length} assets)</span>` : ''}
    </div>
    <div class="card-body">
      <h6>${name}</h6>
      ${locationStateTemplate(location)}
    </div>`

  return cardContentTemplateHtml
}

const locationCardShell = (location, assetsTemplate) => {
  const { id } = location
  return `
    <div class="sidebar-card">
      <div class="main-card">
        <a data-turbo="false" href="/location_management/locations/${id}">${cardContentTemplate(location)}</a>
        ${deploymentCollapsibleHtml(location)}
      </div>
      ${assetsTemplate}
    </div>`
}

window.locationCardTemplates.legacy = (location, showAsset) => {
  const { assets, category } = location
  return locationCardShell(location, locationListAssetsTemplate(assets, showAsset, category))
}

window.locationCardTemplates.static = (location, showAsset) => {
  const { assets, category } = location
  return locationCardShell(location, locationListAssetsTemplate(assets, showAsset, category))
}

window.locationCardTemplates.digital = (location, showAsset) => {
  const { assets, category } = location
  return locationCardShell(location, locationListAssetsTemplate(assets, showAsset, category))
}

window.locationCardTemplates.urban_panel = (location, showAsset) => {
  const { assets, category } = location
  return locationCardShell(location, locationListAssetsTemplate(assets, showAsset, category))
}

window.locationCardTemplates.icon = (location, showAsset) => {
  const { assets, category } = location
  return locationCardShell(location, locationListAssetsTemplate(assets, showAsset, category))
}

window.locationCardTemplates.combo_shelter = (location, showAsset) => {
  const { assets, category, shelter_statuses } = location
  return locationCardShell(location, locationListAssetsTemplate(assets, showAsset, category, shelter_statuses))
}

window.locationCardTemplates.future_location = (location, showAsset) => {
  const { assets, category } = location
  return locationCardShell(location, locationListAssetsTemplate(assets, showAsset, category))
}

window.locationCardTemplates.imh = (location) => {
  const { name, hub_type, pilot_2026, remove, show_path, location_card_icon } = location
  const pilotBadge = pilot_2026 ? '<span class="tag warning-tag">2026 Pilot</span>' : ''
  const removedBadge = remove ? '<span class="tag error-tag">Removed</span>' : ''
  const hubLabel = hub_type === 'primary' ? 'Primary Hub' : 'Satellite'
  const hubBadgeClass = hub_type === 'primary' ? 'primary-tag' : 'secondary-tag'
  const displayName = name || 'IMH Location'

  return `
    <div class="sidebar-card">
      <div class="main-card">
        <a data-turbo="false" href="${show_path || '#'}">
          <div class="card-title">
            ${location_card_icon || ''}
            <span class="tag ${hubBadgeClass}">${hubLabel}</span>
          </div>
          <div class="card-body">
            <h6>${displayName}</h6>
            <div class="flex flex-wrap items-center gap-2 text-sm text-secondary">
              ${pilotBadge}
              ${removedBadge}
            </div>
          </div>
        </a>
      </div>
    </div>
  `
}
